import React from 'react';

const BusinessInformatics = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Business Informatics</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills__name">IT Agile Project Management</h3>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills__name">Agile Development</h3>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills__name">Stakeholder Analysis</h3>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills__name">
                Communication between business and IT
              </h3>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills__name">Low Code Platform Development</h3>
              <span className="skills__level">(Mendix)</span>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
              <h3 className="skills__name">Stakeholder Analysis</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInformatics;
